import React, {useEffect, useState} from "react";
import axios from "axios";
import {useParams} from "react-router-dom";
import {baseUrl, userLocation} from "../Univ.js";
function PurchaseOrderView() {
    const {id} = useParams();
    const [poData, setPoData] = useState({});
    const [itemData, setItemData] = useState([]);
    const [hospitalData, setHospitalData] = useState([]);
    useEffect(() => {
        fetchPO();
        fetchHospital();
    }, []);
    const fetchPO = () => {
        axios
            .get(`${baseUrl}purchase-order/${id}/`)
            .then(async (response) => {
                setPoData(response.data);
                const itemResponse = await axios.get(
                    `${baseUrl}purchase-order-item/`
                );
                const filteredItems = itemResponse.data.filter(
                    x => x.po?.id === response.data.id
                );
                setItemData(filteredItems);
            })
            .catch(error => {
                console.log(error);
            });
    };
    const fetchHospital = () => {
        axios
            .get(`${baseUrl}view-hospital/${userLocation}/`)
            .then(response => {
                setHospitalData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    };
    const handlePrint = () => {
        const printContents =
            document.getElementById("print-area").innerHTML;
        const originalContents =
            document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    };
    return (
        <section className="container mt-4">

            <div id="print-area">
                <div className="table-responsive mt-4">
                    {/* HEADER */}
                    <table className="erp-table-modern">

                        <thead>

                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>

                            <th colSpan="6" className="text-center">

                                {hospitalData.map(hospital => (
                                    <div key={hospital.id}>

                                        <img
                                            src={hospital.logo}
                                            alt="logo"
                                            style={{
                                                width: '80px',
                                                height: '80px'
                                            }}
                                        />

                                        <h3>{hospital.hospital}</h3>

                                        <p>{hospital.address}</p>

                                    </div>
                                ))}

                            </th>

                        </tr>

                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>

                            <th colSpan="6" className="text-center">

                                PURCHASE ORDER

                            </th>

                        </tr>

                        </thead>

                        <tbody>

                        <tr>

                            <th>PO No</th>
                            <td>{poData.po_no}</td>

                            <th>RFQ No</th>
                            <td>{poData.rfq?.rfq_no}</td>

                            <th>Date</th>
                            <td>{poData.add_date}</td>

                        </tr>

                        <tr>

                            <th>Vendor</th>
                            <td>{poData.vendor?.name}</td>

                            <th>Contact</th>
                            <td>{poData.vendor?.mobile}</td>

                            <th>Status</th>
                            <td>{poData.status}</td>

                        </tr>

                        </tbody>

                    </table>
                </div>
                {/* ITEMS */}
                <div className="table-responsive mt-4">

                    <table className="erp-table-modern">

                        <thead style={{backgroundColor: '#1bc5ce', color: 'white'}}>

                        <tr>

                            <th>S.No</th>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Rate</th>
                            <th>GST %</th>
                            <th>Net Amount</th>

                        </tr>

                        </thead>

                        <tbody>

                        {itemData.map((item, index) => (
                            <tr key={index}>

                                <td>{index + 1}</td>
                                <td>{item.product}</td>
                                <td>{item.ordered_qty}</td>
                                <td>₹ {item.rate}</td>
                                <td>{item.gst}%</td>
                                <td>₹ {item.net_amount}</td>

                            </tr>
                        ))}

                        <tr>

                            <th colSpan="5" className="text-end">
                                Total
                            </th>

                            <th>
                                ₹ {poData.total_amount}
                            </th>

                        </tr>

                        </tbody>

                    </table>

                </div>

            </div>

            {/* PRINT BUTTON */}
            <div className="text-center mt-4">

                <button
                    className="btn btn-primary"
                    onClick={handlePrint}
                >
                    Print
                </button>

            </div>

        </section>
    );
}
export default PurchaseOrderView;